import { useMediaStore } from '@/store/pinia/media';

const lib = {
  healInProgressMuteUnmuteState: (user) => {
    /**
     * if someone is muting/unmuting AV and resync state happens,
     * here we'll ensure that resync doesn't override inprogress action.
     */
    const mediaStore = useMediaStore();
    const me = { ...user };
    if (!me.muted && mediaStore.isMuteOrUnmuteInProgress('audioMute')) {
      me.muted = true;
    }
    if (me.muted && mediaStore.isMuteOrUnmuteInProgress('audioUnMute')) {
      me.muted = false;
    }
    if (!me.video_muted && mediaStore.isMuteOrUnmuteInProgress('videoMute')) {
      me.video_muted = true;
    }
    if (me.video_muted && mediaStore.isMuteOrUnmuteInProgress('videoUnMute')) {
      me.video_muted = false;
    }
    return me;
  },
};

export default lib;
